import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  FilterField,
  FilterOfCollection
} from "../../models/FilterOfCollection";
import store from "@/store";
import { mapGetters } from "vuex";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";
import { Field } from "../../models/Field";
import { SelectCollection } from "./logic/SelectCollection";
import Snackbar from "@/shared/components/Snackbar/Snackbar.vue";
import {
  GENERAL_RULES_CONSTANTS,
  TIME_UNITS
} from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import lodash from "lodash";
import {
  DASHBOARD_OPERATORS,
  DASHBOARD_TEMPLATE_EVENTS,
  DASHBOARD_TEMPLATE_MESSAGES,
  DATA_TYPE
} from "../../constants/DashboardTemplatesConstants";
@Component({
  name: "DashboardFilter",
  components: { DynamicSelect },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      actionInFilters: "getActionInFilters"
    })
  }
})
export default class DashboardFilter extends Vue {
  @Prop() indexSectionOfDashboard!: number;
  @Prop() indexCollectionFilter?: number;
  @Prop() indexFilter!: number;
  @Prop() filter?: FilterOfCollection;
  @Prop() collection?: DynamicSelectData;
  @Prop() optionsToIndicator?: DynamicSelectData[];
  @Prop() sizeFilter!: number;

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;

  actionInFilters!: {
    indexSection: number;
    indexCollection: number;
    indexFilter: number;
    field: string;
  };

  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;

  Field = [] as DynamicSelectData[];
  FieldConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false,
    required: true,
    attach: false,
    disabled: false
  };
  lastDocId = "";
  menu = false;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  value: any = "";

  operator = [] as DynamicSelectData[];
  operatorConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false,
    required: true,
    attach: false
  };

  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];

  valueOfField: DynamicSelectData[] | string[] = [];
  isUpdating = false;
  isSearchingOptions = false;

  // Para prevenir bucles en watchers
  lastFilterValue = "";
  lastValueOfField = "";
  lastTimeUnitSelected = "";
  lastOperator = "";
  valueOfFieldConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false,
    required: true,
    attach: false,
    disabled: false
  };
  htmlElement = "";
  nowDate = new Date().toISOString().slice(0, 10);
  date: string[] | string = "";
  lastRef = "";
  timeUnitList = TIME_UNITS;
  timeUnitSelected = "year";
  basicClass = STYLE_CLASSES.BASIC_PRIMARY;

  // Timeout para el debounce del UPDATE_QUERY
  updateQueryTimeout: number | null = null;
  lastkeyword = "";

  mounted() {
    console.log("mounted", this.indexFilter);

    // Inicializar valores para comparación en watchers
    this.lastFilterValue = JSON.stringify(this.filter);
    this.lastValueOfField = JSON.stringify(this.valueOfField);
    this.lastTimeUnitSelected = JSON.stringify(this.timeUnitSelected);
    this.lastOperator = JSON.stringify(this.operator);

    this.loadItems();
    this.getCollectionProperties();
    // this.onSectionsOfDashboardStoreChange();
    if (this.filter && this.filter.value && this.filter.value.length > 0) {
      this.valueOfField = [...this.filter.value];
      this.lastValueOfField = JSON.stringify(this.valueOfField);
    }
  }

  @Watch("collection", { deep: true })
  onSectionsOfDashboardStoreChange() {
    console.log("collection changed");

    this.FieldConfig.listAll = this.collection!.fields!.map((field: Field) => {
      return {
        id: field.field,
        name: field.visualField,
        operators: field.operators,
        type: field.type,
        idList: field.idList,
        child: field.child,
        additionalLogic: field.additionalLogic || ""
      };
    });
  }

  deleteDashboardFilter() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.DELETE_FILTER, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollection: this.indexCollectionFilter,
      indexFilter: this.indexFilter
    });
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_QUERY);
    this.$emit("filterDeleted", this.indexFilter);
  }

  async getCollectionProperties() {
    this.Field =
      (this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
        this.indexCollectionFilter as number
      ].filters[this.indexFilter as number]?.field as DynamicSelectData[]) ||
      this.filter?.field;
    this.changeField(true);
    this.operator =
      (this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
        this.indexCollectionFilter as number
      ].filters[this.indexFilter as number]?.operator as DynamicSelectData[]) ||
      this.filter?.operator;
    await this.getValues();

    this.valueOfField =
      (this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
        this.indexCollectionFilter as number
      ].filters[this.indexFilter as number]?.value as DynamicSelectData[]) ||
      this.filter?.value;

    if (this.filter?.filterFromChart) {
      console.log("getCollectionProperties 1");
      if ((this.filter.field[0] as FilterField).type === DATA_TYPE.LIST) {
        console.log("getCollectionProperties 2");
        this.fixValueOfField();
      }
      console.log("getCollectionProperties 3");
      this.changeValue(true);
    }

    if (this.Field[0]?.type === DATA_TYPE.TIME_STAMP) {
      this.value = (this.valueOfField as unknown) as string;
      this.date = (this.valueOfField as unknown) as string;
    }

    this.FieldConfig.listAll = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections[
      this.indexCollectionFilter as number
    ].collection[0].fields.map(field => {
      return {
        id: field.field,
        name: field.visualField,
        operators: field.operators,
        idList: field.idList,
        type: field.type,
        child: field.child,
        additionalLogic: field.additionalLogic || ""
      };
    });
  }

  changeField(isLoadingItems?: boolean, userClick?: boolean) {
    if (!isLoadingItems && this.validateField()) {
      Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.USED_FIELD);
      return;
    }

    this.getValues("", true);
    console.log("this.filter?.filterFromChart", this.filter?.filterFromChart);

    if (!this.filter?.filterFromChart) {
      store.commit("setDisabledAddCollectionFilterButton", true);
    }

    if (userClick) {
      store.commit("setDisabledAddCollectionFilterButton", true);
    }

    if (this.Field.length == 0) return;
    if (this.Field[0].operators) {
      this.operatorConfig.listAll = this.Field[0].operators
        .split(",")
        .map(operator => ({
          id: this.mapIdOperator(operator),
          name: operator
        }));
      this.operatorConfig.disabled = false;
      if (!isLoadingItems) {
        this.valueOfField = [];
      }
      return;
    }
    this.operatorConfig.listAll = [{ id: "=", name: "=" }];
    this.operator = [{ id: "=", name: "=" }];
    this.operatorConfig.disabled = true;
    this.valueOfFieldConfig.multiple = false;
    if (!isLoadingItems) {
      this.valueOfField = [];
    }
  }

  validateField() {
    const fieldFound = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections[this.indexCollectionFilter as number].filters.find(
      item => (item.field[0] as FilterField)?.id == this.Field[0].id
    );
    if (fieldFound) {
      return true;
    }
    return false;
  }

  mapIdOperator(operator: string) {
    if (operator == DASHBOARD_OPERATORS.BETWEEN) return "BETWEEN";

    return operator;
  }

  async getValues(keyword = "", changeField?: boolean) {
    console.log("getValues", keyword, changeField);
    if (
      this.valueOfFieldConfig.listAll.length > 0 &&
      this.lastDocId == "" &&
      !changeField &&
      this.lastkeyword == keyword
    ) {
      return;
    }
    this.lastkeyword = keyword as string;
    console.log("getValues 1");
    if (this.Field.length == 0) return;
    this.htmlElement = this.Field[0].type as string;
    if (this.Field[0].type !== DATA_TYPE.LIST) {
      return;
    }
    console.log("getValues 2");
    this.isSearchingOptions = true;
    const selectCollection = new SelectCollection();
    const listOfPropertiesValues =
      selectCollection[this.collection!.id as keyof SelectCollection];
    listOfPropertiesValues.setIndexes(
      this.indexSectionOfDashboard,
      this.indexCollectionFilter!
    );
    console.log("getValues 3");

    const fetchData = await listOfPropertiesValues.loadItems(
      this.Field[0].id,
      this.Field[0].idList,
      keyword || "",
      this.lastDocId
    );
    console.log("fetchData", fetchData);

    if (keyword || changeField) {
      console.log("getValues 4");
      this.valueOfFieldConfig.listAll = fetchData.data || [];
      console.log("getValues 5", this.valueOfFieldConfig.listAll);
      this.lastDocId = "";
    } else {
      this.valueOfFieldConfig.listAll = lodash
        .cloneDeep(this.valueOfFieldConfig.listAll)
        .concat(fetchData.data || []);
    }
    if (fetchData.lastDocId) {
      this.lastDocId = fetchData.lastDocId;
    } else {
      this.lastDocId = "";
    }

    if (this.filter!.filterFromChart) {
      const valueOfFieldFound = this.valueOfFieldConfig.listAll.find(
        item =>
          item.id ===
            (this.filter!.value[0 as number] as DynamicSelectData)!.id ||
          item.name.toLocaleUpperCase() ===
            (this.filter!.value[
              0 as number
            ] as DynamicSelectData)!.name.toLocaleUpperCase()
      );

      if (!valueOfFieldFound) {
        if (!this.isUpdating && this.valueOfField.length === 0) {
          this.valueOfField = [];
        }
        this.isSearchingOptions = false;
        return;
      }

      if (!this.isUpdating) {
        this.valueOfField = [
          { id: valueOfFieldFound?.id, name: valueOfFieldFound?.name }
        ];
      }
    }
    this.isSearchingOptions = false;
  }

  @Watch("valueOfField")
  @Watch("timeUnitSelected")
  onValueOfFieldChange() {
    const currentValueOfField = JSON.stringify(this.valueOfField);
    const currentTimeUnit = JSON.stringify(this.timeUnitSelected);

    if (
      this.lastValueOfField === currentValueOfField &&
      this.lastTimeUnitSelected === currentTimeUnit
    ) {
      return;
    }
    console.log("onValueOfFieldChange 2", this.indexCollectionFilter);
    this.lastValueOfField = currentValueOfField;
    this.lastTimeUnitSelected = currentTimeUnit;

    this.changeValue(false);
  }

  changeValue(executeWhenFilterComeFromChart = false) {
    console.log("changeValue 1");
    try {
      if (this.valueOfField.length == 0) return;
      console.log("changeValue 2");
      if (
        this.Field?.[0]?.type === DATA_TYPE.LIST &&
        !executeWhenFilterComeFromChart &&
        !this.filter?.filterFromChart
      ) {
        if (this.isSearchingOptions) return;

        const allAreSelectedOptions = (this.valueOfField as unknown[]).every(
          v => {
            if (typeof v === "string") return false;
            if (
              typeof v === "object" &&
              v !== null &&
              (v as DynamicSelectData).id
            )
              return true;
            return false;
          }
        );
        if (!allAreSelectedOptions) return;
      }
      console.log("changeValue 3");
      if (this.Field[0].type == DATA_TYPE.TIME_UNIT) {
        this.Field[0].description = this.timeUnitSelected;
      }
      this.aditionalContitions();
      const filter: {
        field: DynamicSelectData[];
        operator: DynamicSelectData[];
        value: DynamicSelectData[] | string[];
        filterFromChart?: boolean;
      } = {
        field: this.Field,
        operator: this.operator,
        value: this.valueOfField
      };
      console.log(
        "changeValue 4",
        this.filter?.filterFromChart,
        executeWhenFilterComeFromChart
      );

      if (this.filter?.filterFromChart || executeWhenFilterComeFromChart) {
        filter.filterFromChart = true;
        store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FILTER_ITEM, {
          indexSectionOfDashboard: this.indexSectionOfDashboard,
          indexCollection: this.indexCollectionFilter,
          indexFilter: this.indexFilter,
          filter: filter
        });

        store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_ACTIONS_IN_FILTERS, {
          indexSection: this.indexSectionOfDashboard,
          indexCollection: this.indexCollectionFilter,
          indexFilter: this.indexFilter,
          field: this.Field[0].id
        });
        const storeFiltersCollection = this.sectionsOfDashboardStore[
          this.indexSectionOfDashboard
        ].collections[this.indexCollectionFilter as number].filters;
        console.log("sizeFiltersStore", storeFiltersCollection);

        if (this.sizeFilter == storeFiltersCollection.length) {
          for (const filter of storeFiltersCollection) {
            console.log("filter", filter);
            if (filter == undefined) return;
          }

          console.log("entro");
          this.$emit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_QUERY);
        }
        return;
      }

      this.commitFilter(filter);
    } catch (error) {
      console.log("error", error);
    }
  }

  commitFilter(filter: {
    field: DynamicSelectData[];
    operator: DynamicSelectData[];
    value: DynamicSelectData[] | string[];
    filterFromChart?: boolean;
  }) {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FILTER_ITEM, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollection: this.indexCollectionFilter,
      indexFilter: this.indexFilter,
      filter: filter
    });

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_ACTIONS_IN_FILTERS, {
      indexSection: this.indexSectionOfDashboard,
      indexCollection: this.indexCollectionFilter,
      indexFilter: this.indexFilter,
      field: this.Field[0].id
    });
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_QUERY);
  }

  @Watch("filter")
  changeFilter() {
    console.log("changeFilter", this.indexFilter);
    if (!this.filter) return;

    const currentFilter = JSON.stringify(this.filter);
    if (this.lastFilterValue === currentFilter) {
      return;
    }
    this.lastFilterValue = currentFilter;

    if (
      JSON.stringify(this.valueOfField) !== JSON.stringify(this.filter.value)
    ) {
      if (
        (this.filter.field[0] as FilterField).type === DATA_TYPE.LIST &&
        this.filter.filterFromChart
      ) {
        this.fixValueOfField();
      } else {
        console.log("this.filter.value", this.filter.value);
        this.operator = lodash.cloneDeep(
          this.filter.operator
        ) as DynamicSelectData[];

        console.log("this.valueOfField", this.valueOfField);
        this.valueOfField = [...this.filter.value];

        if (this.Field[0].type == DATA_TYPE.TIME_STAMP) {
          const normalizedValue = this.normalizeFilterValue(this.filter.value);
          this.value = normalizedValue;
          this.date = normalizedValue;
        }
      }
    }
  }

  fixValueOfField() {
    let valueOfFieldFound = this.valueOfFieldConfig.listAll.find(
      item => item.id === this.filter!.value[0].id
    );
    console.log("this.filter!.value[0].name", this.filter!.value[0].name);
    console.log(
      "this.valueOfFieldConfig.listAll",
      this.valueOfFieldConfig.listAll
    );
    if (!valueOfFieldFound) {
      valueOfFieldFound = this.valueOfFieldConfig.listAll.find(
        item =>
          item.name.toLocaleUpperCase() ===
          this.filter!.value[0].name.toLocaleUpperCase()
      );
    }
    console.log("valueOfFieldFound", valueOfFieldFound);

    if (valueOfFieldFound) {
      this.valueOfField = [
        {
          id: valueOfFieldFound?.id as string,
          name: valueOfFieldFound?.name as string
        }
      ];
    }
  }

  loadItems() {
    console.log("loadItems");
    if (this.filter?.field && this.filter?.field.length > 0) {
      this.Field = this.filter.field as FilterField[];
      this.operator = this.filter.operator as [];

      if (!this.isUpdating) {
        this.valueOfField = JSON.parse(JSON.stringify(this.filter.value));
      }

      if ((this.filter.field[0] as FilterField).type == DATA_TYPE.TIME_STAMP) {
        this.date = lodash.cloneDeep(this.filter.value);
        this.value = this.date;
      }
      if (this.Field[0].type == DATA_TYPE.TIME_UNIT) {
        this.timeUnitSelected = (this.filter.field[0] as FilterField)
          .description as string;
      }
      this.changeField(true);
    }
  }

  @Watch("operator")
  changeOperator() {
    const currentOperator = JSON.stringify(this.operator);
    if (this.lastOperator === currentOperator) {
      return;
    }

    this.lastOperator = currentOperator;

    if (this.filter?.filterFromChart) {
      return;
    }

    this.valueOfField = [];
  }

  changeOperatorClick() {
    store.commit("setDisabledAddCollectionFilterButton", true);
  }

  saveDate(date: string | string[]) {
    if (Array.isArray(date)) {
      if (date.length === 1) {
        Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.MUST_BE_RANGE);
        return;
      }

      const date1 = new Date(date[0]).getTime();
      const date2 = new Date(date[1]).getTime();

      if (date1 > date2) {
        date = [date[1], date[0]];
      }
    } else {
      date = [date];
    }
    this.value = date;
    this.menu = false;
    this.date = date;

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FILTER_ITEM, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollection: this.indexCollectionFilter,
      indexFilter: this.indexFilter,
      filter: {
        field: this.Field,
        operator: this.operator,
        value: this.date
      }
    });
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_QUERY);
  }

  @Watch("actionInFilters")
  changeActionInFilters() {
    if (
      this.actionInFilters.indexSection == this.indexSectionOfDashboard &&
      this.actionInFilters.indexCollection == this.indexCollectionFilter &&
      this.actionInFilters.indexFilter !== this.indexFilter &&
      this.Field[0]?.child
    ) {
      const valueFound = this.sectionsOfDashboardStore[
        this.indexSectionOfDashboard
      ].collections[this.indexCollectionFilter as number].filters.find(
        item => (item.field[0] as FilterField)?.id == this.Field[0].child
      );

      if (valueFound) {
        this.FieldConfig.disabled = true;
        this.valueOfFieldConfig.disabled = true;
        return;
      }

      if (!valueFound && this.Field[0].child == this.actionInFilters.field) {
        this.FieldConfig.disabled = true;
        this.valueOfFieldConfig.disabled = true;
        return;
      }

      this.FieldConfig.disabled = false;
      this.valueOfFieldConfig.disabled = false;
    }
  }

  setTimeUnit(timeUnit: { label: string; value: string }) {
    this.timeUnitSelected = timeUnit.value;
  }

  getMoreData(event: string) {
    console.log("getMoreData", event);
    this.getValues(event);
  }

  normalizeFilterValue(value: any): string | string[] {
    if (!value) return "";

    if (Array.isArray(value)) {
      const dates = value
        .map(item => {
          if (typeof item === "string") return item;
          if (typeof item === "object" && item && item.id) return item.id;
          if (typeof item === "object" && item && item.name) return item.name;
          return String(item);
        })
        .filter(d => d && d !== "null" && d !== "undefined");

      return dates.length === 1 ? dates[0] : dates;
    }

    if (typeof value === "object" && value) {
      return value.id || value.name || String(value);
    }

    return String(value);
  }

  /*  beforeDestroy() {
     if (this.updateQueryTimeout) {
       clearTimeout(this.updateQueryTimeout);
       this.updateQueryTimeout = null;
     }
   } */

  async aditionalContitions() {
    console.log("aditionalContitions 1", this.Field);
    if (!this.Field[0].additionalLogic) return;
    console.log("aditionalContitions 2", this.valueOfField);

    const selectCollection = new SelectCollection();
    const listOfPropertiesValues =
      selectCollection[this.collection!.id as keyof SelectCollection];

    const additionalfunction = (listOfPropertiesValues as any)[
      this.Field[0].additionalLogic
    ];

    if (!additionalfunction) return;

    const response = await additionalfunction(this.valueOfField);

    console.log("response", response);
    for (const item of response) {
      if (item.function && item.data) {
        this[item.function as keyof DashboardFilter](item.data);
      }
    }
  }

  addNewField(data: { id: string; name: string; fields: any[] }) {
    console.log("addNewField", data);
    this.$emit("addNewField", {
      field: data.id,
      visualField: data.name,
      operators: "=",
      type: "list",
      fields: data.fields
    });
    console.log("this.FieldConfig.listAll", this.FieldConfig.listAll);
  }

  removeField(data: { id: string; name: string }) {
    console.log("removeField", data);
    this.$emit("removeField", data.id);
  }
}
